import React, { useRef, useEffect } from "react";

interface CanvasStripperProps {
  imageUrl: string;
  stripesCount: number;
  direction: "vertical" | "horizontal";
  strips: (stripsArray: Strip[]) => void;
}

interface Strip {
  index: number;
  urls: string;
}

const CanvasStripper = ({ imageUrl, stripesCount, direction, strips }: CanvasStripperProps): JSX.Element => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.crossOrigin = "Anonymous"; // Для работы с кросс-доменными изображениями

    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      
      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const isVertical = direction === "vertical";
      const stripeSize = isVertical
        ? img.width / stripesCount
        : img.height / stripesCount;

      const stripsArray: Strip[] = [];

      for (let i = 0; i < stripesCount; i++) {
        canvas.width = isVertical ? stripeSize : img.width;
        canvas.height = isVertical ? img.height : stripeSize;

        ctx.drawImage(
          img,
          isVertical ? i * stripeSize : 0,
          isVertical ? 0 : i * stripeSize,
          isVertical ? stripeSize : img.width,
          isVertical ? img.height : stripeSize,
          0,
          0,
          isVertical ? stripeSize : img.width,
          isVertical ? img.height : stripeSize
        );

        stripsArray.push({
          index: i,
          urls: canvas.toDataURL()
        });
      }

      strips(stripsArray);
    };

    img.onerror = () => {
      console.error("Failed to load image");
    };
  }, [imageUrl, stripesCount, direction, strips]);

  return <canvas ref={canvasRef} style={{ display: "none" }} />;
};

export default CanvasStripper;